<section class="container-fluid"> 

    <div class="row">
        <div class="col-12"  style="text-align: center;">
    <h2>Todos los Palcos de la localidad {{localidad?.nombre}}</h2>

    
    <button class="btn btn-success" routerLink="/administradores/admin/eventos/lista/etapas/{{miIdEvento}}/localidades/{{idEtapa}}">Atras</button>
    <br>
    <br>
    <button  routerLink="agregar" class="btn btn-success">Agregar Palco</button>
    <button  (click)="voltear()" class="btn btn-success">Voltear</button>
    <p>Palcos Vendidos: {{palcosVendidos}} </p>
    <p>Palcos Por Vender: {{palcosPorVender}}</p>
    <p>Dinero Dinero Recaudado para entregar al organizador: {{dineroRecaudado|currency:'COP'}}</p>
    <div *ngIf ='message' class="alert alert-success ">{{message}}</div>

    <table class="table mt-3">

        <thead>
            <tr>
                <th>Id</th>
                <th>Nombre</th>
                <th>Numero Dentro Del Evento</th>
                <th>Precio</th>
                <th>Cantidad Pagada</th>
                <th>Servicio</th>
                <th>IVA</th>
                <th>Plata a dar al organizador</th>
                <th>Personas Adentro</th>
                <th>Personas Maximas</th>

                <th>Vendido</th>
                <th>Reservado</th>
                <th>En proceso</th>
                <th>Esta Disponible</th>

                <th>Reservar</th>
                <th>Proceso</th>
                <th>Disponible</th>
                <th>VENDER A MANO</th>
                <th>Borrar</th>
                
            </tr>
    
    
    
        </thead>
        <tbody>
          
            <tr *ngFor = "let palco of localidad?.palcos">
                <td>{{palco?.id}}</td>
                <td>{{palco?.nombre }}</td>
                <td>{{palco?.numeroDentroDeEvento}}</td>
                <td>{{palco?.precio  | currency :'COP'}}</td>
                <td>{{palco?.precioParcialPagado|currency:'COP'}}</td>
                <td>{{palco?.servicio | currency :'COP'}}</td>
                <td>{{palco?.servicioIva | currency :'COP'}}</td>
                <td>{{dineroRecaudadoPalcos(palco) | currency :'COP'}}</td>
                <td>{{palco?.personasAdentro}}</td>
                <td>{{palco?.personasMaximas}}</td>
                <td>{{palco?.vendido  |booleans}}</td>
                <td>{{palco?.reservado  |booleans}}</td>
                <td>{{palco?.proceso  |booleans}}</td>
                <td>{{palco?.disponible  |booleans}}</td>

                <td><button class="btn btn-warning" (click)="marcarReservado(palco.id)"> Modificar</button></td>

                <td><button class="btn btn-warning" (click)="marcarComoProceso(palco.id)"> PROCESO</button></td>
                <td><button class="btn btn-success" (click)="marcarComoDisponible(palco.id)"> Marcar disónibilidad</button></td>
                <td><button class="btn btn-success" (click)="marcarComoVendido(palco.id)"> VENDER A MANO</button></td>
                <td><button (click) ="borrarPalco(palco.id)" class="btn btn-danger"> Delete</button></td>
    
            </tr>
    
    
        </tbody>
    
    </table>

<div class="row">
    <div class="col-12 mt-5" style="text-align: center;">


</div>
</div>
</div>
</div>
</section>

